import React from 'react';
import { Line,Bar } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";

export default function linea(props) {
    const {Data}=props;
    const data = {
        labels: ["January", "February", "March", "April", "May", "June"],
        datasets: [{
            label: "Revenue",
            backgroundColor: "#4e73df",
            hoverBackgroundColor: "#2e59d9",
            borderColor: "#4e73df",
            data: [4215, 5312, 6251, 7841, 9821, 14984],
        }]
    };

    const options = {
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 10,
                right: 25,
                top: 25,
                bottom: 0
            }
        },
    };

    return (
        <Line data={Data} options={options}/>
    )
}
